module.exports = __webpack_public_path__ + "files/c59f3e0a857335409ead50a8701f3909.png";